module.exports = __webpack_public_path__ + "static/media/pia-logo@2x.a7cb78c0.png";